import React, { useState, useEffect, useRef } from 'react';
import { useContext } from 'react';
import { UserContext } from '../context/UserContext';
import { db } from '../firebase/firebaseConfig';
import Alertas from './Alertas';
import EnviarCorreo from '../funciones/EnviarCorreo';
import { getDocs, collection, where, query, updateDoc, doc, writeBatch } from 'firebase/firestore';
import moment from 'moment';
import ReactDOMServer from 'react-dom/server';
import { Segment, Table, Modal, Button, Container, Accordion, Icon, Header, Dropdown, Checkbox, Message, Label } from 'semantic-ui-react';
import Swal from 'sweetalert2';
/* import ExportarExcel from '../funciones/ExportarExcel'; */
import { PDFViewer } from "@react-pdf/renderer";
import SimplePDF from './SimplePDF';
import Presupuesto from './ReportePresupuestoPDF';
import { crearNotificacion } from "../funciones/Notificaciones";

const Asignar = () => {
    //fecha hoy
    const fechaHoy = new Date();
    /*  const user = auth.currentUser; */

    const { users } = useContext(UserContext);
    const [asignar, setAsignar] = useState([]);
    const [asignados, setAsignados] = useState([]);
    const [cerrados, setCerrados] = useState([]);
    const [mostrarDet, setMostrarDet] = useState([]);
    const [testIngreso, setTestIngreso] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    const [idCabIngreso, setIdCabIngreso] = useState(null)
    /*  const [buscador, setBuscador] = useState('') */
    /* const [buscador2, setBuscador2] = useState('') */
    const [openModalCli, setOpenModalCli] = useState(false);
    const [OpenModalAsignar, setOpenModalAsignar] = useState(false);
    const [tecnico, setTecnico] = useState('')
    const [alerta, cambiarAlerta] = useState({});
    const [estadoAlerta, cambiarEstadoAlerta] = useState(false);
    const [flag, setFlag] = useState(false);
    const [tituloModal, setTituloModal] = useState('');
    const [mostrarSelec, setMostrarSelec] = useState(false);
    // Estado para almacenar los ítems seleccionados
    const [selectedItems, setSelectedItems] = useState([]);
    //Estado para controlar el indice abierto en acordeon
    const [activeIndex, setActiveIndex] = useState(null);
    const [openPdf2, setOpenPdf2] = useState(false);
    const [datospdf, setDatosPdf] = useState([]);
    const [test, setTest] = useState([]);
    const [openPdf, setOpenPdf] = useState(false);
    const [testGpdf, setTestGpdf] = useState([]);
    const [usuarioIngreso, setUsuarioIngreso] = useState([]);
    const [ingresado, setIngresado] = useState([]);
    const [userAdd, setUsersAdd] = useState([]);
    const [cabecera, setCabecera] = useState([]);
    const [presup, setPresu] = useState([]);
    const [falla, setFalla] = useState([]);
    const [total, setTotal] = useState(0);


    const idCab = useRef();

    // Leer datos de cabecera Ingresados
    const getIngresostcab = async () => {
        if (!users) return;
        const traerCabecera = collection(db, 'ingresostcab');
        const dato = query(traerCabecera, where('emp_id', '==', users.emp_id), where('estado', '==', 'INGRESADO'));
        const data = await getDocs(dato)
        setAsignar(data.docs.map((doc, index) => ({ ...doc.data(), id: doc.id, id2: index + 1 })))

    }

    const consultarIn = async () => {
        if (!users) return;
        const ing = query(collection(db, 'ingresostcab'), where('emp_id', '==', users.emp_id), where('confirmado', '==', true));
        const ingreso = await getDocs(ing);
        const existeIn = (ingreso.docs.map((doc, index) => ({ ...doc.data(), id: doc.id })))
        setIngresado(existeIn.sort((a, b) => a.folio - b.folio));
    }

    // Leer datos de cabecera Asignados
    const getAsignadoscab = async () => {
        if (!users) return;
        const traerCabecera = collection(db, 'ingresostcab');
        const dato = query(traerCabecera, where('emp_id', '==', users.emp_id), where('estado', '==', 'ASIGNADO'));
        const data = await getDocs(dato)
        setAsignados(data.docs.map((doc, index) => ({ ...doc.data(), id: doc.id, id2: index + 1 })))
    }

    // Leer datos de cabecera REALIZADOS
    const getCerradoscab = async () => {
        if (!users) return;
        const traerCabecera = collection(db, 'ingresostcab');
        const dato = query(traerCabecera, where('emp_id', '==', users.emp_id), where('estado', '==', 'REALIZADO'));
        const data = await getDocs(dato)
        setCerrados(data.docs.map((doc, index) => ({ ...doc.data(), id: doc.id, id2: index + 1 })))
    }


    // Leer datos de cabecera Entradas
    const leerIngresoCab = async (id, indice) => {
        if (indice === 1) {
            const docum = asignar.filter(leer => leer.id === id);
            setMostrarDet(docum);
        } else if (indice === 2) {
            const docum = asignados.filter(leer => leer.id === id);
            setMostrarDet(docum);
        } else {
            const docum = cerrados.filter(leer => leer.id === id);
            setMostrarDet(docum);
        }

    }

    // Función para manejar la selección de ítems
    const handleCheck = (item) => {
        // Si el ítem ya está seleccionado, lo eliminamos de selectedItems
        if (selectedItems.some(selected => selected.id === item.id)) {
            setSelectedItems(selectedItems.filter(selected => selected.id !== item.id));
        } else {
            // Si no está seleccionado, lo añadimos al arreglo selectedItems
            setSelectedItems([...selectedItems, item]);
        }
    };


    // Cambiar fecha timestap format date
    const formatearFecha = (fecha) => {
        const dateObj = fecha.toDate();
        const formatear = moment(dateObj).format('DD/MM/YYYY HH:mm');
        /*  const fechaHoyF = moment(fechaHoy).format('DD/MM/YYYY HH:mm');
         console.log(fechaHoyF + " es menor que ? " + formatear, fechaHoy < dateObj) */
        return formatear;
    }

    const leerTestIngreso = async (id) => {
        if (!users) return;
        const traer = collection(db, 'testingreso');
        const doc = query(traer, where('id_cab_inst', '==', id));
        const documento = await getDocs(doc)
        setTestIngreso(documento.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
    }

    testIngreso.sort((a, b) => a.fechamod - b.fechamod)

    const leerUsuarios = async () => {
        if (!users?.emp_id) return;

        const traerRef = collection(db, "usuarios");
        const q = query(traerRef, where("emp_id", "==", users.emp_id));
        const snap = await getDocs(q);

        const todos = snap.docs.map(d => ({ ...d.data(), id: d.id }));
        const activos = todos.filter(u => u.activo === true);

        setUsuarioIngreso(todos); // todos
        setUsuarios(activos);     // solo activos
    };


    //Ordenar x folio
    const asignarOrd = asignar.sort((a, b) => a.folio - b.folio)
    //Ordenar por nombre de tecnico
    const asignadosOrd = asignados.map(obj => {
        const nomTecnico = usuarioIngreso.find(u => u.correo === obj.tecnico);
        return { ...obj, nombre: nomTecnico.nombre + ' ' + nomTecnico.apellido }
    })
        .sort((a, b) => {
            const nameComparison = a.nombre.localeCompare(b.nombre);
            if (nameComparison === 0) {
                return a.folio - b.folio;
            }
            return nameComparison;
        });


    const asignarUsuario = async (e) => {
        e.preventDefault();

        cambiarEstadoAlerta(false);
        cambiarAlerta({});

        if (!tecnico || tecnico === "Selecciona Tecnico:") {
            cambiarEstadoAlerta(true);
            cambiarAlerta({
                tipo: "error",
                mensaje: "Favor seleccione un usuario",
            });
            return;
        }

        try {
            const folioOrden = mostrarDet?.[0]?.folio ?? "";

            await updateDoc(doc(db, "ingresostcab", idCabIngreso), {
                tecnico: tecnico,
                estado: "ASIGNADO",
                estado_servicio: "EN PROCESO",
                fechamod: new Date(),
            });

            try {
                await crearNotificacion({
                    titulo: "Nueva orden asignada",
                    mensaje: `Se te asignó la orden N° ${folioOrden}`,
                    tipo: "ORDEN_ASIGNADA",
                    emp_id: users.emp_id,
                    para: [tecnico],
                    link: "/serviciotecnico/asignadostecnicos",
                    data: {
                        ordenId: idCabIngreso,
                        folio: folioOrden,
                        tecnico: tecnico,
                    },
                });
            } catch (errorNotif) {
                console.error("Error al crear notificación:", errorNotif);
            }

            cambiarEstadoAlerta(true);
            cambiarAlerta({
                tipo: "exito",
                mensaje: "Usuario reasignado correctamente",
            });

            setFlag((prev) => !prev);
            setOpenModalAsignar(false);
            setOpenModalCli(false);
            setTecnico("");
        } catch (error) {
            console.error("Error al actualizar técnico:", error);

            cambiarEstadoAlerta(true);
            cambiarAlerta({
                tipo: "error",
                mensaje: `Error al actualizar técnico: ${error.message || error}`,
            });
        }
    };

    //Funcion handlesubmit para validar y asignar
    const asignarUsuarioSelect = async (e) => {
        e.preventDefault();
        cambiarEstadoAlerta(false);
        cambiarAlerta({});
        // Validación: Verificar si al menos un ítem está seleccionado
        const isValidSelection = selectedItems.length > 0;

        if (tecnico.length === 0 || tecnico === 'Selecciona Tecnico:') {
            cambiarEstadoAlerta(true);
            cambiarAlerta({
                tipo: 'error',
                mensaje: 'Favor seleccione un usuario'
            })
            return;
        } else if (!isValidSelection) {
            cambiarEstadoAlerta(true);
            cambiarAlerta({
                tipo: 'error',
                mensaje: 'No hay ningun item seleccionado'
            })
        }

        else {
            // Crea una nueva instancia de lote (batch)
            const batch = writeBatch(db);
            // Itera a través de los nuevos documentos y agrégalos al lote de Checks
            selectedItems.forEach((docs) => {
                const nuevoDocRef = doc(db, 'ingresostcab', docs.id); // Crea una referencia de documento vacía (Firestore asignará un ID automáticamente)
                batch.update(nuevoDocRef, {
                    tecnico: tecnico,
                    estado: 'ASIGNADO',
                    fechamod: fechaHoy
                });
            });
            batch.commit()
                .then(async () => {
                    await Promise.all(
                        selectedItems.map((item) =>
                            crearNotificacion({
                                titulo: "Nueva orden asignada",
                                mensaje: `Se te asignó la orden N° ${item.folio}`,
                                tipo: "ORDEN_ASIGNADA",
                                emp_id: users.emp_id,
                                para: [tecnico],
                                link: "/serviciotecnico/asignadostecnicos",
                                data: {
                                    ordenId: item.id,
                                    folio: item.folio,
                                    tecnico: tecnico,
                                },
                            })
                        )
                    );
                    try {
                        // EnviarCorreo(tecnico, 'Asignación de Orden de Ingreso', `Se le ha asignado la orden de ingreso N. ${mostrarDet[0].folio}`)
                        selectedItems.forEach((destino, index) => {
                            EnviarCorreo(tecnico, 'Asignación de Orden de Ingreso', cuerpoCorreo(selectedItems, index))
                        })
                    } catch (error) {
                        console.log('error', error)
                        Swal.fire('Se ha producido un error al enviar correo');
                    }
                    setFlag(!flag)
                })
                .catch((error) => {
                    Swal.fire('Se ha producido un error al crear docuemento');
                    console.log(error)
                });
        }
        setTecnico('');
    }
    //Exportar a excel los equipos
    /*     const ExportarXls = () => {
            //Campos a mostrar en el excel   
            const columnsToShow = ['folio', 'rut', 'entidad', 'date', 'tipo', 'modelo', 'serie', 'servicio', 'fecha_out']
            //Llamar a la funcion con props: array equipo y array columnas
            const excelBlob = ExportarExcel(exporta, columnsToShow);
            // Crear un objeto URL para el Blob y crear un enlace de descarga
            const excelURL = URL.createObjectURL(excelBlob);
            const downloadLink = document.createElement('a');
            downloadLink.href = excelURL;
            downloadLink.download = 'OrdenesCerradas.xlsx';
            downloadLink.click();
        } */

    const cuerpoCorreo = (data, indiceProps) => {
        const d = data[indiceProps];

        // estilos reusables (inline-friendly)
        const wrap = {
            backgroundColor: '#EEF2EF',
            textAlign: 'center',
            padding: '24px',                 // menor padding para móvil
        };
        const card = {
            backgroundColor: '#EAF1FB',
            margin: '0 auto',
            width: '100%',
            maxWidth: '640px',               // límite de ancho seguro
            textAlign: 'left',               // mejor legibilidad en móvil
            borderRadius: '0px',
        };
        const header = {
            backgroundColor: '#3A9A9D',
            fontSize: '20px',
            color: '#ffffff',
            margin: 0,
            padding: '14px 18px',
            textAlign: 'center',
        };
        const sectionTitle = {
            padding: '12px 16px',
            fontSize: '18px',
            textAlign: 'left',
            margin: 0,
            fontWeight: '600',
        };
        const tableBase = {
            borderCollapse: 'collapse',
            border: '4px solid #C8C8C8',
            width: '100%',                   // SIEMPRE 100%
            tableLayout: 'fixed',            // evita desborde
            letterSpacing: '0.2px',
            fontSize: '14px',
            backgroundColor: '#FFFFFF',
        };
        const th = {
            border: '4px solid #BEBEBE',
            padding: '10px 12px',
            backgroundColor: '#EBEBEB',
            textAlign: 'left',
            verticalAlign: 'top',
            width: '40%',                    // clave
            wordBreak: 'break-word',
            overflowWrap: 'anywhere',
        };
        const td = {
            border: '4px solid #BEBEBE',
            padding: '10px 12px',
            backgroundColor: '#F5F5F5',
            textAlign: 'left',
            verticalAlign: 'top',
            wordBreak: 'break-word',
            overflowWrap: 'anywhere',
        };
        const spacer = { height: '16px', lineHeight: '16px' };

        // helper para filas clave:valor (más legible en móvil)
        const Row = ({ label, value, valueStyle }) => (
            <tr>
                <th style={th}>{label}</th>
                <td style={{ ...td, ...(valueStyle || {}) }}>{value ?? '-'}</td>
            </tr>
        );

        return ReactDOMServer.renderToString(
            <div style={wrap}>
                <div style={{ ...card, padding: 0 }}>
                    <h2 style={header}>
                        Se le ha asignado la Orden de Ingreso N° {d.folio}
                    </h2>

                    {/* --- Informacion Cliente (formato clave:valor responsivo) --- */}
                    <div style={spacer}>&nbsp;</div>
                    <h3 style={sectionTitle}>Información Cliente</h3>
                    <table style={tableBase} role="presentation" cellPadding="0" cellSpacing="0">
                        <tbody>
                            <Row label="Rut" value={d.rut} />
                            <Row label="Nombre" value={d.entidad} />
                            <Row label="Fecha" value={formatearFecha(d.date)} />
                            <Row label="Teléfono" value={d.telefono} />
                            <Row label="Dirección" value={d.direccion} />
                            <Row label="Correo" value={d.correo} />
                        </tbody>
                    </table>

                    {/* --- Informacion Equipo --- */}
                    <div style={spacer}>&nbsp;</div>
                    <h3 style={sectionTitle}>Información Equipo</h3>
                    <table style={tableBase} role="presentation" cellPadding="0" cellSpacing="0">
                        <tbody>
                            <Row label="Familia" value={d.familia} />
                            <Row label="Tipo Equipamiento" value={d.tipo} />
                            <Row label="Marca" value={d.marca} />
                            <Row label="Modelo" value={d.modelo} />
                            <Row label="Serie" value={d.serie} />
                            <Row label="Servicio" value={d.servicio} valueStyle={{ color: 'red', fontWeight: 600 }} />
                        </tbody>
                    </table>

                    {/* --- Observaciones --- */}
                    <div style={spacer}>&nbsp;</div>
                    <h3 style={sectionTitle}>Observaciones</h3>
                    <table style={tableBase} role="presentation" cellPadding="0" cellSpacing="0">
                        <tbody>
                            <Row label="Detalle" value={d.observaciones} />
                        </tbody>
                    </table>

                    <div style={{ height: '24px', lineHeight: '24px' }}>&nbsp;</div>
                </div>
            </div>
        );
    };

    //Funcion para agrupoar por usuarios
    const agruparUsuario = (data) => {
        return data.reduce((result, currentItem) => {
            const { nombre } = currentItem;
            if (!result[nombre]) {
                result[nombre] = []; // Si el título no existe en el resultado, lo inicializamos como array
            }
            result[nombre].push(currentItem); // Añadimos el item completo al array del título correspondiente
            return result;
        }, {});
    };
    //LLAmada a funcion para agrupar x tecnicos
    const tecnicos = agruparUsuario(asignadosOrd);
    // Función para manejar el clic en el acordeón
    const handleClick = (index) => {
        const newIndex = activeIndex === index ? -1 : index; // Toggle para abrir/cerrar
        setActiveIndex(newIndex);
    };

    //***** Ver Pdf orden de ingreso ****
    const verPdf = async (id) => {
        try {
            // Filtrar y obtener el documento directamente
            const datosFiltrados = ingresado.filter((item) => item.id === id);
            setDatosPdf(datosFiltrados);

            // Consulta los tests ingreso
            const test = query(
                collection(db, 'testingreso'),
                where('emp_id', '==', users.emp_id),
                where('id_cab_inst', '==', id)
            );
            const testIn = await getDocs(test);
            const existeTest = testIn.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
            setTest(existeTest.sort((a, b) => a.fechamod - b.fechamod));

            //Consulta los tes de garantia
            const testG = query(
                collection(db, 'testevaluacion'),
                where('emp_id', '==', users.emp_id),
                where('id_cab_inst', '==', id)
            );
            const testInG = await getDocs(testG);
            const existeTestG = testInG.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
            setTestGpdf(existeTestG.sort((a, b) => a.fechamod - b.fechamod));

            // Verificar que los datos existan antes de extraer useradd
            if (datosFiltrados.length > 0) {
                const useradd = datosFiltrados[0].useradd;
                const usuarioFiltrado = usuarioIngreso.filter(
                    (usuario) => usuario.correo === useradd
                );
                setUsersAdd(usuarioFiltrado);
            } else {
                console.error("No se encontraron datos para el PDF.");
            }
            setOpenPdf(true);
        } catch (error) {
            console.error("Error al cargar datos para el PDF:", error);
        }
    }

    //***** Ver Pdf orden de Presupuesto ****
    const verPdfPresu = async (id) => {
        try {
            //Leer datos de cabecera
            const datosFiltrados = ingresado.filter(item => item.id === id);
            setCabecera(datosFiltrados);

            //Leer cabecera de presupuesto
            const preCab = query(collection(db, 'presupuestoscab'), where('emp_id', '==', users.emp_id), where('id_cab_inst', '==', id));
            const presuCab = await getDocs(preCab);
            const existePreCab = (presuCab.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
            idCab.current = existePreCab[0].id;

            // Detalle de Ingreso de equipo => Funcional
            const pre = query(collection(db, 'presupuestos'), where('emp_id', '==', users.emp_id), where('id_cab_pre', '==', idCab.current));
            const presus = await getDocs(pre);
            const existePresupuesto = (presus.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
            setPresu(existePresupuesto.filter(p => p.categoria === 'REPUESTO' || p.categoria === 'SERVICIO'));
            setFalla(existePresupuesto.filter(f => f.categoria === 'FALLA'));
            // setTotal(existePresupuesto.reduce((total, dato) => total + dato.price, 0));
            setTotal(
                existePresupuesto.reduce((total, dato) => total + parseFloat(dato.price || 0), 0)
            );
            // Verificar que los datos existan antes de extraer usermod
            if (existePreCab.length > 0) {
                const useradd = existePreCab[0].usermod;
                const usuarioFiltrado = usuarioIngreso.filter(
                    (usuario) => usuario.correo === useradd
                );
                setUsersAdd(usuarioFiltrado);
            }

        } catch (error) {
            console.error('Error al obtener los datos del presupuesto:', error);
        }
        setOpenPdf2(true);
    }

    useEffect(() => {
        getIngresostcab();
        leerUsuarios();
        getAsignadoscab();
        getCerradoscab();
        getAsignadoscab();
        consultarIn();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [users])
    useEffect(() => {
        getIngresostcab();
        getAsignadoscab();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [flag, setFlag])

    return (
        <Container fluid style={{ background: "#f8fafc", minHeight: "100vh", padding: "18px 16px 35px" }}>
            <Container fluid style={{ maxWidth: 1400 }}>

                {/* CABECERA */}
                <Segment style={{ border: "1px solid #e5e7eb", borderRadius: 8, boxShadow: "0 1px 3px rgba(0,0,0,.06)", padding: "18px 20px", marginBottom: 16 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
                        <div style={{ width: 46, height: 46, borderRadius: 8, background: "#e8f8f7", display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <Icon name="tasks" color="teal" size="large" style={{ margin: 0 }} />
                        </div>

                        <Header as="h2" style={{ margin: 0, color: "#1f2937", fontSize: 21 }}>
                            Asignación de Ingresos
                            <Header.Subheader style={{ marginTop: 5 }}>
                                Asignar órdenes ingresadas a técnicos y revisar trabajos en proceso
                            </Header.Subheader>
                        </Header>
                    </div>
                </Segment>

                {/* RESUMEN */}
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(210px, 1fr))", gap: 12, marginBottom: 16 }}>
                    <Segment style={{ margin: 0, border: "1px solid #e5e7eb", borderRadius: 8, boxShadow: "0 1px 3px rgba(0,0,0,.05)" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                            <Icon name="inbox" color="teal" size="large" />
                            <div>
                                <div style={{ color: "#6b7280", fontSize: 12 }}>Por asignar</div>
                                <div style={{ fontSize: 23, fontWeight: 700, color: "#1f2937" }}>{asignarOrd.length}</div>
                            </div>
                        </div>
                    </Segment>

                    <Segment style={{ margin: 0, border: "1px solid #e5e7eb", borderRadius: 8, boxShadow: "0 1px 3px rgba(0,0,0,.05)" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                            <Icon name="user wrench" color="teal" size="large" />
                            <div>
                                <div style={{ color: "#6b7280", fontSize: 12 }}>Asignadas</div>
                                <div style={{ fontSize: 23, fontWeight: 700, color: "#1f2937" }}>{asignados.length}</div>
                            </div>
                        </div>
                    </Segment>

                    <Segment style={{ margin: 0, border: "1px solid #e5e7eb", borderRadius: 8, boxShadow: "0 1px 3px rgba(0,0,0,.05)" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                            <Icon name="users" color="teal" size="large" />
                            <div>
                                <div style={{ color: "#6b7280", fontSize: 12 }}>Técnicos con órdenes</div>
                                <div style={{ fontSize: 23, fontWeight: 700, color: "#1f2937" }}>{Object.keys(tecnicos).length}</div>
                            </div>
                        </div>
                    </Segment>
                </div>

                {/* POR ASIGNAR */}
                <Segment style={{ border: "1px solid #e5e7eb", borderRadius: 8, boxShadow: "0 1px 3px rgba(0,0,0,.06)", padding: 0, overflow: "hidden", marginBottom: 16 }}>
                    <div style={{ padding: "14px 16px", borderBottom: "1px solid #e5e7eb", display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12 }}>
                        <Header as="h3" style={{ margin: 0, fontSize: 17 }}>
                            <Icon name="inbox" color="teal" />
                            <Header.Content>
                                Por asignar
                                <Header.Subheader>Órdenes ingresadas pendientes de asignación</Header.Subheader>
                            </Header.Content>
                        </Header>

                        <Label basic color="teal">{asignarOrd.length} pendiente(s)</Label>
                    </div>

                    {asignarOrd.length > 0 && (
                        <div style={{ padding: 14, background: "#f9fafb", borderBottom: "1px solid #e5e7eb" }}>
                            <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
                                <div style={{ flex: 1, minWidth: 260 }}>
                                    <Dropdown
                                        fluid search selection
                                        placeholder="Selecciona técnico"
                                        value={tecnico || ""}
                                        onChange={(e, { value }) => setTecnico(value)}
                                        options={usuarios.map((u) => ({
                                            key: u.id,
                                            text: `${u.nombre} ${u.apellido}`,
                                            value: u.correo
                                        }))}
                                    />
                                </div>

                                <Button
                                    color="teal"
                                    onClick={asignarUsuarioSelect}
                                    disabled={!tecnico || selectedItems.length === 0}
                                    title={selectedItems.length === 0 ? "Selecciona al menos una orden" : "Asignar seleccionados"}
                                >
                                    <Icon name="user plus" />
                                    Asignar seleccionados ({selectedItems.length})
                                </Button>

                                {selectedItems.length > 0 && (
                                    <Button basic color="grey" onClick={() => setSelectedItems([])} type="button">
                                        <Icon name="close" />
                                        Limpiar
                                    </Button>
                                )}
                            </div>
                        </div>
                    )}

                    <div style={{ overflowX: "auto", overflowY: "auto", maxHeight: 520 }}>
                        <Table celled striped selectable compact="very" singleLine style={{ fontSize: 12, margin: 0 }}>
                            <Table.Header style={{ position: "sticky", top: 0, zIndex: 2 }}>
                                <Table.Row>
                                    <Table.HeaderCell width={1} textAlign="center">Sel.</Table.HeaderCell>
                                    <Table.HeaderCell width={1} textAlign="center">#</Table.HeaderCell>
                                    <Table.HeaderCell>Orden</Table.HeaderCell>
                                    <Table.HeaderCell>Fecha ingreso</Table.HeaderCell>
                                    <Table.HeaderCell>Equipo</Table.HeaderCell>
                                    <Table.HeaderCell>Modelo</Table.HeaderCell>
                                    <Table.HeaderCell>N° Serie</Table.HeaderCell>
                                    <Table.HeaderCell>Servicio</Table.HeaderCell>
                                    <Table.HeaderCell width={1} textAlign="center">Detalle</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>

                            <Table.Body>
                                {asignarOrd.map((item, index) => (
                                    <Table.Row key={item.id ?? index}>
                                        <Table.Cell textAlign="center">
                                            <Checkbox
                                                checked={selectedItems.some((s) => s.id === item.id)}
                                                onChange={() => handleCheck(item)}
                                            />
                                        </Table.Cell>

                                        <Table.Cell textAlign="center">{index + 1}</Table.Cell>
                                        <Table.Cell style={{ fontWeight: 600 }}>{item.folio}</Table.Cell>
                                        <Table.Cell>{formatearFecha(item.date)}</Table.Cell>
                                        <Table.Cell>{item.tipo}</Table.Cell>
                                        <Table.Cell>{item.modelo}</Table.Cell>
                                        <Table.Cell>{item.serie}</Table.Cell>

                                        <Table.Cell>
                                            <Label basic color="teal" size="tiny">{item.servicio}</Label>
                                        </Table.Cell>

                                        <Table.Cell textAlign="center">
                                            <Button
                                                basic compact icon size="mini"
                                                title="Ver detalle"
                                                onClick={() => {
                                                    setIdCabIngreso(item.id);
                                                    leerIngresoCab(item.id, 1);
                                                    leerTestIngreso(item.id);
                                                    setTituloModal("Asignar Ingreso");
                                                    setMostrarSelec(true);
                                                    setOpenModalCli(true);
                                                }}
                                                style={{ background: "#fff", boxShadow: "none" }}
                                            >
                                                <Icon name="eye outline" color="blue" style={{ margin: 0, fontSize: "1.2em" }} />
                                            </Button>
                                        </Table.Cell>
                                    </Table.Row>
                                ))}

                                {asignarOrd.length === 0 && (
                                    <Table.Row>
                                        <Table.Cell colSpan="9" textAlign="center" style={{ padding: 30, color: "#6b7280" }}>
                                            <Icon name="check circle outline" color="grey" size="large" />
                                            <div style={{ marginTop: 7 }}>No hay ingresos pendientes de asignación.</div>
                                        </Table.Cell>
                                    </Table.Row>
                                )}
                            </Table.Body>
                        </Table>
                    </div>
                </Segment>

                {/* ASIGNADOS */}
                <Segment style={{ border: "1px solid #e5e7eb", borderRadius: 8, boxShadow: "0 1px 3px rgba(0,0,0,.06)", padding: 0, overflow: "hidden", marginBottom: 16 }}>
                    <div style={{ padding: "14px 16px", borderBottom: "1px solid #e5e7eb", display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12 }}>
                        <Header as="h3" style={{ margin: 0, fontSize: 17 }}>
                            <Icon name="users" color="teal" />
                            <Header.Content>
                                Asignados
                                <Header.Subheader>Órdenes agrupadas por técnico responsable</Header.Subheader>
                            </Header.Content>
                        </Header>

                        <Label basic color="teal">{asignados.length} asignada(s)</Label>
                    </div>

                    <div style={{ padding: 14 }}>
                        {Object.keys(tecnicos).length === 0 ? (
                            <Message>
                                <Icon name="inbox" />
                                No hay órdenes asignadas.
                            </Message>
                        ) : (
                            <Accordion fluid styled>
                                {Object.keys(tecnicos).map((title, index) => (
                                    <div key={title}>
                                        <Accordion.Title
                                            active={activeIndex === index}
                                            index={index}
                                            onClick={() => handleClick(index)}
                                            style={{ textAlign: "left", fontSize: 14, padding: "13px 15px" }}
                                        >
                                            <Icon name="dropdown" />
                                            <Icon name="user wrench" color="teal" />
                                            <b style={{ color: "#374151" }}>{title}</b>
                                            <Label basic color="teal" size="tiny" style={{ marginLeft: 10 }}>
                                                {tecnicos[title].length} orden(es)
                                            </Label>
                                        </Accordion.Title>

                                        <Accordion.Content active={activeIndex === index}>
                                            <div style={{ overflowX: "auto" }}>
                                                <Table celled striped selectable compact="very" singleLine style={{ fontSize: 12 }}>
                                                    <Table.Header>
                                                        <Table.Row>
                                                            <Table.HeaderCell>Orden</Table.HeaderCell>
                                                            <Table.HeaderCell>Fecha ingreso</Table.HeaderCell>
                                                            <Table.HeaderCell>Equipo</Table.HeaderCell>
                                                            <Table.HeaderCell>Modelo</Table.HeaderCell>
                                                            <Table.HeaderCell>N° Serie</Table.HeaderCell>
                                                            <Table.HeaderCell>Servicio inicial</Table.HeaderCell>
                                                            <Table.HeaderCell>Servicio nuevo</Table.HeaderCell>
                                                            <Table.HeaderCell>Fecha asignación</Table.HeaderCell>
                                                            <Table.HeaderCell>Técnico</Table.HeaderCell>
                                                            <Table.HeaderCell textAlign="center">Detalle</Table.HeaderCell>
                                                            <Table.HeaderCell textAlign="center">Orden</Table.HeaderCell>
                                                            <Table.HeaderCell textAlign="center">Presu.</Table.HeaderCell>
                                                            <Table.HeaderCell textAlign="center">Reasignar</Table.HeaderCell>
                                                        </Table.Row>
                                                    </Table.Header>

                                                    <Table.Body>
                                                        {tecnicos[title].map((item, idx) => {
                                                            const tienePresupuesto =
                                                                (item.servicio === "PRESUPUESTO" || item.servicionew === "PRESUPUESTO") &&
                                                                item.estado_servicio !== "";

                                                            return (
                                                                <Table.Row key={item.id ?? idx}>
                                                                    <Table.Cell style={{ fontWeight: 600 }}>{item.folio}</Table.Cell>
                                                                    <Table.Cell>{formatearFecha(item.date)}</Table.Cell>
                                                                    <Table.Cell>{item.tipo}</Table.Cell>
                                                                    <Table.Cell>{item.modelo}</Table.Cell>
                                                                    <Table.Cell>{item.serie}</Table.Cell>

                                                                    <Table.Cell>
                                                                        <Label basic color="grey" size="tiny">{item.servicio || "—"}</Label>
                                                                    </Table.Cell>

                                                                    <Table.Cell>
                                                                        {item.servicionew ? (
                                                                            <Label basic color="teal" size="tiny">{item.servicionew}</Label>
                                                                        ) : "—"}
                                                                    </Table.Cell>

                                                                    <Table.Cell>{formatearFecha(item.fechamod)}</Table.Cell>
                                                                    <Table.Cell>{item.nombre}</Table.Cell>

                                                                    <Table.Cell textAlign="center">
                                                                        <Button
                                                                            basic compact icon size="mini"
                                                                            title="Ver detalle"
                                                                            onClick={() => {
                                                                                leerTestIngreso(item.id);
                                                                                leerIngresoCab(item.id, 2);
                                                                                setTituloModal("Detalle de Ingreso");
                                                                                setMostrarSelec(false);
                                                                                setOpenModalCli(true);
                                                                            }}
                                                                            style={{ background: "#fff", boxShadow: "none" }}
                                                                        >
                                                                            <Icon name="eye outline" color="blue" style={{ margin: 0, fontSize: "1.2em" }} />
                                                                        </Button>
                                                                    </Table.Cell>

                                                                    <Table.Cell textAlign="center">
                                                                        <Button
                                                                            basic compact icon size="mini"
                                                                            onClick={() => verPdf(item.id)}
                                                                            title="Ver PDF Orden"
                                                                            style={{ color: "#db2828", background: "#fff", boxShadow: "none" }}
                                                                        >
                                                                            <Icon name="file pdf outline" color="red" style={{ margin: 0, fontSize: "1.25em" }} />
                                                                        </Button>
                                                                    </Table.Cell>

                                                                    <Table.Cell textAlign="center">
                                                                        <Button
                                                                            basic compact icon size="mini"
                                                                            disabled={!tienePresupuesto}
                                                                            onClick={tienePresupuesto ? () => verPdfPresu(item.id) : undefined}
                                                                            title={tienePresupuesto ? "Ver PDF Presupuesto" : "Presupuesto no disponible"}
                                                                            style={{
                                                                                color: tienePresupuesto ? "#db2828" : undefined,
                                                                                background: "#fff",
                                                                                boxShadow: "none"
                                                                            }}
                                                                        >
                                                                            <Icon
                                                                                name="file pdf outline"
                                                                                color={tienePresupuesto ? "red" : "grey"}
                                                                                style={{ margin: 0, fontSize: "1.25em" }}
                                                                            />
                                                                        </Button>
                                                                    </Table.Cell>

                                                                    <Table.Cell textAlign="center">
                                                                        {item.enproceso === "1" ? (
                                                                            <Icon name="sync" color="red" title="En proceso" />
                                                                        ) : (
                                                                            <Button
                                                                                basic compact icon size="mini"
                                                                                color="blue"
                                                                                title="Reasignar técnico"
                                                                                onClick={() => {
                                                                                    setIdCabIngreso(item.id);
                                                                                    setMostrarDet([item]);
                                                                                    setTecnico("");
                                                                                    setTituloModal("Re asignar usuario");
                                                                                    setOpenModalAsignar(true);
                                                                                }}
                                                                            >
                                                                                <Icon name="exchange" style={{ margin: 0 }} />
                                                                            </Button>
                                                                        )}
                                                                    </Table.Cell>
                                                                </Table.Row>
                                                            );
                                                        })}
                                                    </Table.Body>
                                                </Table>
                                            </div>
                                        </Accordion.Content>
                                    </div>
                                ))}
                            </Accordion>
                        )}
                    </div>
                </Segment>

                <Alertas
                    tipo={alerta.tipo}
                    mensaje={alerta.mensaje}
                    estadoAlerta={estadoAlerta}
                    cambiarEstadoAlerta={cambiarEstadoAlerta}
                />

                {/* MODAL DETALLE / ASIGNACIÓN */}
                <Modal open={openModalCli} onClose={() => setOpenModalCli(false)} size="large" closeIcon>
                    <Modal.Header>
                        <Icon name={mostrarSelec ? "user plus" : "clipboard outline"} color="teal" />
                        {tituloModal}
                    </Modal.Header>

                    <Modal.Content scrolling>
                        <Header as="h4" color="teal">
                            <Icon name="user outline" />
                            Información Cliente
                        </Header>

                        <div style={{ overflowX: "auto" }}>
                            <Table celled compact="very" singleLine>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell>N° Orden</Table.HeaderCell>
                                        <Table.HeaderCell>Rut</Table.HeaderCell>
                                        <Table.HeaderCell>Cliente</Table.HeaderCell>
                                        <Table.HeaderCell>Teléfono</Table.HeaderCell>
                                        <Table.HeaderCell>Dirección</Table.HeaderCell>
                                        <Table.HeaderCell>Email</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>

                                <Table.Body>
                                    {mostrarDet.map((item, index) => (
                                        <Table.Row key={index}>
                                            <Table.Cell style={{ fontWeight: 600 }}>{item.folio}</Table.Cell>
                                            <Table.Cell>{item.rut}</Table.Cell>
                                            <Table.Cell>{item.entidad}</Table.Cell>
                                            <Table.Cell>{item.telefono}</Table.Cell>
                                            <Table.Cell>{item.direccion}</Table.Cell>
                                            <Table.Cell>{item.correo}</Table.Cell>
                                        </Table.Row>
                                    ))}
                                </Table.Body>
                            </Table>
                        </div>

                        <Header as="h4" color="teal" style={{ marginTop: 22 }}>
                            <Icon name="tasks" />
                            Test de Ingreso
                        </Header>

                        <Table celled compact="very">
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell width={1}>#</Table.HeaderCell>
                                    <Table.HeaderCell>Item</Table.HeaderCell>
                                    <Table.HeaderCell width={1} textAlign="center">Sí</Table.HeaderCell>
                                    <Table.HeaderCell width={1} textAlign="center">No</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>

                            <Table.Body>
                                {testIngreso.map((item, index) => (
                                    <Table.Row key={index}>
                                        <Table.Cell>{index + 1}</Table.Cell>
                                        <Table.Cell style={{ whiteSpace: "normal" }}>{item.item}</Table.Cell>
                                        <Table.Cell textAlign="center"><Checkbox checked={item.valorsi} readOnly /></Table.Cell>
                                        <Table.Cell textAlign="center"><Checkbox checked={item.valorno} readOnly /></Table.Cell>
                                    </Table.Row>
                                ))}
                            </Table.Body>
                        </Table>

                        {mostrarDet?.[0]?.observaciones && (
                            <Message info>
                                <Icon name="comment alternate outline" />
                                <b>Observaciones:</b> {mostrarDet[0].observaciones}
                            </Message>
                        )}

                        {mostrarSelec && (
                            <Segment secondary style={{ marginTop: 20 }}>
                                <Header as="h4" color="teal">
                                    <Icon name="user plus" />
                                    Asignar Técnico
                                </Header>

                                <Dropdown
                                    fluid search selection
                                    placeholder="Selecciona técnico"
                                    value={tecnico || ""}
                                    onChange={(e, { value }) => setTecnico(value)}
                                    options={usuarios.map((u) => ({
                                        key: u.id,
                                        text: `${u.nombre} ${u.apellido}`,
                                        value: u.correo
                                    }))}
                                />
                            </Segment>
                        )}
                    </Modal.Content>

                    <Modal.Actions>
                        <Button basic onClick={() => setOpenModalCli(false)}>
                            <Icon name="close" />
                            Cerrar
                        </Button>

                        {mostrarSelec && (
                            <Button color="teal" onClick={asignarUsuario} disabled={!tecnico}>
                                <Icon name="user plus" />
                                Asignar
                            </Button>
                        )}
                    </Modal.Actions>
                </Modal>

                {/* MODAL REASIGNAR */}
                <Modal open={OpenModalAsignar} onClose={() => setOpenModalAsignar(false)} size="small" closeIcon>
                    <Modal.Header>
                        <Icon name="exchange" color="teal" />
                        {tituloModal || "Re asignar usuario"}
                    </Modal.Header>

                    <Modal.Content>
                        <Header as="h4">Seleccionar nuevo técnico</Header>
                        <Dropdown
                            fluid search selection
                            placeholder="Selecciona técnico"
                            value={tecnico || ""}
                            onChange={(e, { value }) => setTecnico(value)}
                            options={usuarios.map((u) => ({
                                key: u.id,
                                text: `${u.nombre} ${u.apellido}`,
                                value: u.correo
                            }))}
                        />
                    </Modal.Content>

                    <Modal.Actions>
                        <Button basic onClick={() => setOpenModalAsignar(false)}>
                            <Icon name="close" />
                            Cancelar
                        </Button>

                        <Button color="teal" onClick={asignarUsuario} disabled={!tecnico}>
                            <Icon name="save" />
                            Guardar
                        </Button>
                    </Modal.Actions>
                </Modal>

                {/* PDF ORDEN DE INGRESO */}
                <Modal open={openPdf} onClose={() => setOpenPdf(false)} size="large" closeIcon>
                    <Modal.Header>
                        <Icon name="file pdf outline" color="red" />
                        Orden de Ingreso
                    </Modal.Header>

                    <Modal.Content style={{ padding: 0 }}>
                        <PDFViewer width="100%" height="560" style={{ border: 0 }}>
                            <SimplePDF
                                props={datospdf}
                                test={test}
                                testGpdf={testGpdf}
                                usuario={userAdd}
                                empresa={users.emp_id}
                            />
                        </PDFViewer>
                    </Modal.Content>

                    <Modal.Actions>
                        <Button color="teal" onClick={() => setOpenPdf(false)}>
                            <Icon name="close" />
                            Cerrar
                        </Button>
                    </Modal.Actions>
                </Modal>

                {/* PDF PRESUPUESTO */}
                <Modal open={openPdf2} onClose={() => setOpenPdf2(false)} size="large" closeIcon>
                    <Modal.Header>
                        <Icon name="file pdf outline" color="red" />
                        Presupuesto
                    </Modal.Header>

                    <Modal.Content style={{ padding: 0 }}>
                        <PDFViewer width="100%" height="560" style={{ border: 0 }}>
                            <Presupuesto
                                cabecera={cabecera}
                                falla={falla}
                                presu={presup}
                                total={total}
                                usuario={userAdd}
                                empresa={users.emp_id}
                            />
                        </PDFViewer>
                    </Modal.Content>

                    <Modal.Actions>
                        <Button color="teal" onClick={() => setOpenPdf2(false)}>
                            <Icon name="close" />
                            Cerrar
                        </Button>
                    </Modal.Actions>
                </Modal>

            </Container>
        </Container>
    );

};

export default Asignar;